module.exports = __webpack_public_path__ + "static/media/u.i_pencil.644c3ffc.png";